import { render, staticRenderFns } from "./SODetailedDialog.vue?vue&type=template&id=0705d8e2"
import script from "./SODetailedDialog.vue?vue&type=script&lang=js"
export * from "./SODetailedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports